export default __webpack_public_path__ + "static/media/edanra.a5b8b2ca.png";